import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUncategorized = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#cccccc",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99999 15C11.866 15 15 11.866 15 8.00001C15 4.134 11.866 1 7.99999 1C4.13401 1 1 4.134 1 8.00001C1 11.866 4.13401 15 7.99999 15Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.2 6.09302C6.19951 5.76249 6.2925 5.43856 6.46823 5.15862C6.64396 4.87867 6.89527 4.65412 7.19316 4.51088C7.49105 4.36765 7.82337 4.31157 8.15176 4.34911C8.48015 4.38666 8.79121 4.51629 9.04907 4.72306C9.30697 4.92983 9.50111 5.20531 9.60911 5.51769C9.71711 5.83008 9.73463 6.16663 9.65951 6.48853C9.58445 6.81043 9.41988 7.10453 9.18482 7.33688C8.94976 7.56928 8.65378 7.73044 8.33104 7.80177C8.22519 7.82265 8.12971 7.87931 8.06062 7.96223C7.99158 8.04519 7.95314 8.14931 7.95174 8.25722V8.77714",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.95264 11.5336C7.88813 11.5336 7.83586 11.4813 7.83586 11.4168C7.83586 11.3524 7.88813 11.3 7.95264 11.3",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.95305 11.5336C8.01756 11.5336 8.06983 11.4813 8.06983 11.4168C8.06983 11.3524 8.01756 11.3 7.95305 11.3",
			stroke: "currentColor"
		})
	] })
});
export default SvgUncategorized;
